import getTitle from 'helpers/getTitle'
import Translate from 'modules/local/Translate'
import React from 'react'
import {NullAsDefault} from 'views/Shared'
import {renderIf} from "../../../Shared";
import {GoDotFill} from 'react-icons/go'
import {Link} from 'react-router-dom'
import getLinkToDetail from '../../../../helpers/getLinkToDetail'
import classNames from "classnames";
import {GradeActionTypes} from '../../../AppLocals/Course'
import dayjs from "dayjs";
import {BsExclamationTriangle} from "react-icons/bs";
import {PiWarning} from "react-icons/pi";

export const renderCourseClassGrade =
    ({renderContextMenu = NullAsDefault, handleAction = NullAsDefault} = {}) =>
        (item, index) => {
            const {subject, total_students_has_score, total_students, grade_date, number_of_sessions,  score_type} = item ?? {}

            const dateObj = grade_date ? dayjs(grade_date) : null

            const percent_num = total_students > 0
                ? parseFloat(((total_students_has_score / total_students) * 100).toFixed(1))
                : 0

            let barColor = 'bg-color-100'
            let percentColor = 'text-color-300'
            let borderColor = 'border-color-100'
            let bgColor = 'background-100'

            if (total_students > 0) {
                if (percent_num >= 75) {
                    barColor = 'bg-green-500'
                    percentColor = 'text-green-500'
                    borderColor = 'border-green-400'
                    bgColor = 'bg-green-50 text-green-600'
                } else if (percent_num >= 50) {
                    barColor = 'bg-blue-500'
                    percentColor = 'text-blue-500'
                    borderColor = 'border-blue-400'
                    bgColor = 'bg-blue-50 text-blue-600'
                } else if (percent_num > 0) {
                    barColor = 'bg-red-400'
                    percentColor = 'text-red-500'
                    borderColor = 'border-red-400'
                    bgColor = 'bg-primary-50 text-primary-600'
                }
            }

            return (
                <Translate key={index}>
                    {(t) => (
                        <div className="p-3 flex items-center gap-3 custom-item-render relative list-item">
                            {/* Date badge */}
                            {dateObj ? (
                                <div
                                    style={{width: 46, height: 46}}
                                    className={classNames(
                                        "px-2 py-1.5 flex flex-col flex-center rounded-lg flex-shrink-0",
                                        borderColor, bgColor, percent_num >= 50 ? 'border-2' : 'border'
                                    )}>
                                    <span className="font-bold text-base leading-none">
                                        {dateObj.format('DD')}
                                    </span>
                                    <span className="mt-0.5 text-2xs text-color-300 leading-tight tracking-wide">
                                        {dateObj.format('MM/YY')}
                                    </span>
                                </div>
                            ) : (
                                <div
                                    className="flex flex-col items-center justify-center rounded-lg border border-color-50 px-2 py-1.5 flex-shrink-0 background-50"
                                    style={{minWidth: 44}}>
                                    <span className="text-xs text-color-300">—</span>
                                </div>
                            )}

                            {/* Title + subject */}
                            <div
                                onClick={() => handleAction(GradeActionTypes.GRADE_DETAIL, item)}
                                className="flex-1 min-w-0 cursor-pointer flex flex-col gap-0.5">
                                <span className="font-bold text-sm text-color-000 hover:text-primary truncate">
                                    {getTitle(item)}
                                </span>
                                {subject && (
                                    <div className="flex items-center gap-1 text-xs text-color-400 whitespace-no-wrap">
                                        {/*<span className="font-medium text-color-300 truncate">*/}
                                        {/*    {getTitle(subject)}*/}
                                        {/*</span>*/}
                                        <GoDotFill size={8} className="ml-2 text-slate-400 flex-shrink-0"/>
                                        {`${t('score type')}: `}
                                        <span className="font-semibold text-slate-500">
                                            {t(score_type)}
                                        </span>
                                    </div>
                                )}
                                {!!item?.course_class_exam?.id && (
                                    <div className="flex flex-wrap items-center gap-2 mt-0.5">
                                        {/* Exam đang mở */}
                                        {item?.course_class_exam?.status === 1 && (
                                            <Link
                                                to={getLinkToDetail(item?.course_class_exam)}
                                                onClick={e => e.stopPropagation()}
                                                className="text-xs font-semibold px-1.5 py-0.5 rounded bg-indigo-50 text-indigo-500 no-underline hover:bg-indigo-100">
                                                {t('exam')}
                                            </Link>
                                        )}
                                        {/* Exam chưa khai báo — amber badge đã có onClick để edit, không cần thêm "edit exam" */}
                                        {item?.course_class_exam?.status === -1 && !!item?.edit && (
                                            <span
                                                onClick={e => {
                                                    e.stopPropagation()
                                                    handleAction(GradeActionTypes.COURSE_CLASS_EXAM_UPDATE, item?.course_class_exam)
                                                }}
                                                style={{
                                                    padding: '0.135rem 0.5rem',
                                                    cursor: 'pointer',
                                                }}
                                                className="flex items-center gap-1 text-amber-600 border border-amber-200 bg-amber-50 hover:bg-amber-100 rounded-md">
                                                <PiWarning size={12}/>
                                                <span className="font-semibold text-xs">
                                                    {t('exam not declared')}
                                                </span>
                                            </span>
                                        )}
                                        {/* Exam đã đóng */}
                                        {item?.course_class_exam?.status === 9 && (
                                            <span className="text-xs font-semibold px-1.5 py-0.5 rounded bg-gray-50 text-gray-400 border border-gray-200">
                                                {t('exam closed')}
                                            </span>
                                        )}
                                        {/* Edit exam — chỉ hiện khi exam đã được khai báo (status !== -1) để tránh trùng với badge cảnh báo */}
                                        {!!item?.edit && item?.course_class_exam?.status !== -1 && (
                                            <span
                                                onClick={e => {
                                                    e.stopPropagation()
                                                    handleAction(GradeActionTypes.COURSE_CLASS_EXAM_UPDATE, item?.course_class_exam)
                                                }}
                                                className="text-xs font-semibold text-blue-500 hover:text-blue-600 cursor-pointer">
                                                {t('edit exam')}
                                            </span>
                                        )}
                                    </div>
                                )}
                            </div>

                            {/* Graded stats */}
                            {total_students > 0 && (
                                <div className="flex flex-col items-end gap-0.5 flex-shrink-0">
                                    <div className="flex items-center gap-1.5">
                                        <div
                                            style={{width: 60}}
                                            className="h-1.5 rounded-full overflow-hidden bg-color-50 hidden sm:block">
                                            <div
                                                className={classNames("h-full rounded-full transition-all", barColor)}
                                                style={{width: `${Math.min(percent_num, 100)}%`}}
                                            />
                                        </div>
                                        <span className={classNames("font-bold text-xs text-right", percentColor)}>
                                            {percent_num.toFixed(1)}%
                                        </span>
                                    </div>
                                    <span className="text-2xs text-color-400 italic whitespace-nowrap">
                                        {`${total_students_has_score}/${total_students} ${t('graded')}`}
                                    </span>
                                </div>
                            )}

                            {renderIf(
                                item?.course_class?.edit && renderContextMenu,
                                <div className="mb-auto contextIcon flex-shrink-0">
                                    {renderContextMenu(item)}
                                </div>
                            )}
                        </div>
                    )}
                </Translate>
            )
        }
